import { render } from "./alarmIcon.vue?vue&type=template&id=0771ccb0"
import script from "./alarmIcon.vue?vue&type=script&lang=js"
export * from "./alarmIcon.vue?vue&type=script&lang=js"

import "./alarmIcon.vue?vue&type=style&index=0&id=0771ccb0&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__